import { EventManagerSVG } from '@common_components/svg/eventManager.svg';
import { BaseIconComponent, IconProps } from '@umanforge/common';

const EventManagerIcon: React.FC<Omit<IconProps, 'svg'>> = props => {
  return <BaseIconComponent {...props} svg={<EventManagerSVG />} />;
};

export { EventManagerIcon };